import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { brand, values } from "../data/siteData";
import { useTranslation } from "react-i18next";
import { aboutTextApi } from "../api/aboutApi";
import "./About.css";

export default function About() {
  const brandColor = "#002244";
  const { t, i18n } = useTranslation();

  const [aboutText, setAboutText] = useState(null);

  // dilə görə seç (aboutText üçün)
  const pick = (obj, base) => {
    const lang = (i18n?.language || "az").toLowerCase();
    const suffix = lang.startsWith("en") ? "En" : lang.startsWith("ru") ? "Ru" : "Az";

    // DTO camelCase: textAz, missionAz
    const keyCamel = `${base}${suffix}`; // textAz
    const keyPascal = `${base[0].toUpperCase() + base.slice(1)}${suffix}`; // TextAz ehtimal
    return obj?.[keyCamel] ?? obj?.[keyPascal] ?? obj?.[`${base}Az`] ?? obj?.[`${base[0].toUpperCase() + base.slice(1)}Az`] ?? "";
  };

  // values üçün də dilə görə seç (əgər titleAz/descAz kimi varsa)
  const pickValue = (obj, base) => {
    const lang = (i18n?.language || "az").toLowerCase();
    const suffix = lang.startsWith("en") ? "En" : lang.startsWith("ru") ? "Ru" : "Az";

    const keyCamel = `${base}${suffix}`; // titleAz / descEn
    const keyPascal = `${base[0].toUpperCase() + base.slice(1)}${suffix}`; // TitleAz ehtimal

    // fallback: title/desc plain
    return obj?.[keyCamel] ?? obj?.[keyPascal] ?? obj?.[base] ?? "";
  };

  useEffect(() => {
    const load = async () => {
      try {
        const res = await aboutTextApi.get();
        setAboutText(res.data || null);
      } catch {
        setAboutText(null);
      }
    };
    load();
  }, []);

  const companyText = pick(aboutText, "text");
  const missionText = pick(aboutText, "mission");

  return (
    <Layout>
      <section className="py-5 aboutPage" style={{ ["--brand"]: brandColor }}>
        <div className="container">
          <div className="mb-4">
            <h1 className="hTitle mb-1">{t("about_title")}</h1>
            <p className="pMuted mb-0">{t("about_subtitle")}</p>
          </div>

          <div className="row g-3">
            <div className="col-12 col-lg-6">
              <div className="aboutCard h-100">
                <h3 className="aboutCardTitle mb-2">{brand?.name}</h3>

                {/* company text */}
                <p style={{ textAlign: "justify" }} className="aboutText mb-3">
                  {companyText ? (
                    companyText
                  ) : (
                    <span style={{ opacity: 0.7 }}>{t("about_no_content")}</span>
                  )}
                </p>

                <div className="aboutMission">
                  <div className="aboutMissionLabel">{t("mission")}</div>

                  <div style={{textAlign:"justify"}} className="aboutMissionText">
                    {missionText ? (
                      missionText
                    ) : (
                      <span style={{ opacity: 0.7 }}>{t("about_no_mission")}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* values */}
            <div className="col-12 col-lg-6">
              <div className="aboutCard h-100">
                <div className="d-flex align-items-end justify-content-between gap-2 mb-2">
                  <h3 className="aboutCardTitle mb-0">{t("values_title")}</h3>
                  <span className="aboutBadge">Scoriva</span>
                </div>

                <div className="row g-2">
                  {(values || []).map((v, idx) => (
                    <div key={v.id ?? v.title ?? idx} className="col-12 col-sm-6">
                      <div className="aboutValueCard h-100">
                        <div className="aboutValueTitle">{pickValue(v, "title")}</div>
                        <div className="aboutValueDesc">{pickValue(v, "desc")}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="aboutFooter mt-4">
            <div className="aboutFooterLine" />
            <div className="aboutFooterText">
              {t("about_footer", { brand: brand?.name || "Scoriva" })}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
